import { MantineThemeOverride } from "@mantine/core";
import { client_selected } from "../client";

export const theme: MantineThemeOverride = {
  colorScheme: "light",
  colors: client_selected.colors,
  fontFamily: "Montserrat",
  // Estilos globais da aplicação
  globalStyles: () => ({
    // Remove as setas (spin buttons) dos inputs type="number" em navegadores Webkit (Chrome, Edge, etc.)
    // "input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button":
    //   {
    // WebkitAppearance: "none",
    // margin: 0,
    // },
    // Remove as setas no Firefox
    // 'input[type="number"]': {
    // MozAppearance: "textfield",
    // },
  }),
  breakpoints: {
    xl: "1600px",
  },
  components: {
    Highlight: {
      styles: () => ({
        root: {
          "& [data-highlight]": {
            backgroundColor: "unset",
            fontWeight: 600,
          },
        },
      }),
    },
    InputWrapper: {
      styles: (theme) => ({
        root: {
          position: "relative",
        },
        label: {
          fontWeight: 600,
          fontSize: "14px",
          color: theme.colors.basic[5],
          whiteSpace: "nowrap",
        },
        error: {
          position: "absolute",
          bottom: "-20px",
          fontSize: "16px",
          fontWeight: 600,
          color: theme.colors.alerts[0],
          paddingTop: "5px",
        },
      }),
    },
    NumberInput: {
      styles: () => ({
        rightSection: { marginRight: "-12px", overflow: "hidden" },
      }),
    },
    Input: {
      styles: (theme) => ({
        label: {
          whiteSpace: "nowrap",
        },
        rightSection: {
          right: "16px",
        },
        icon: {
          left: "8px",
        },
        wrapper: {
          marginBottom: "0px !important",
          boxSizing: "border-box",
          borderRadius: "8px",
          WebkitBorderRadius: "8px",
          outline: `1.5px solid ${theme.colors.basic[2]}`,
          fontFamily: "Montserrat",
          fontStyle: "normal",
          marginTop: "8px ",
          ":disabled": {
            cursor: "not-allowed",
          },
          ":has(input:disabled)": {
            cursor: "not-allowed",
          },
          Input: {
            whiteSpace: "nowrap",
            padding: "12px 16px",
            backgroundColor: theme.colors.basic[0],
            height: "56px !important",
            fontSize: "16px",
            lineHeight: "155%",
            color: theme.colors.basic[5],
            outline: `1.5px solid ${theme.colors.basic[2]}`,
            borderRadius: "8px",
            WebkitBorderRadius: "8px",
            "::placeholder": {
              fontWeight: "lighter",
              color: theme.colors.basic[5],
            },
            ":hover": {
              borderColor: theme.colors.primary[1],
            },
            // ":focus-visible": {
            //   outline: `none`,
            //   fontWeight: "bolder",
            //   color: theme.colors.basic[5],
            //   background: theme.colors.basic[1],
            //   borderColor: theme.colors.primary[1],
            // },
            ":disabled": {
              cursor: "not-allowed",
              background: theme.colors.basic[2],
              opacity: "1",
              "::placeholder": {
                color: theme.colors.basic[5],
              },
            },
            "&#username": {
              paddingLeft: "42px",
            },
          },
        },
      }),
    },
    Select: {
      styles: (theme) => ({
        root: {},
        input: {
          padding: "12px 40px 12px 16px !important",
          textOverflow: "ellipsis !important",
          "&#select": {
            paddingLeft: "60px",
          },
        },
        icon: {
          left: "16px",
        },
        rightSection: {
          right: "6px",
          pointerEvents: "none",
          width: "45px",
        },
        dropdown: {
          borderRadius: "0 0 8px 8px",
          background: theme.colors.other[6],
          border: `1.5px solid ${theme.colors.primary[1]}`,
          borderTop: "none",
          marginTop: "-15px",
        },
        item: {
          borderRadius: "0",
          paddingTop: "16px",
          height: "56px",
          background: theme.colors.basic[0],
          borderTop: theme.colors.basic[3],
          ":hover": {
            background: theme.colors.primaryOpacity[2],
          },
          "&[data-selected]": {
            "&, &:hover": {
              backgroundColor: theme.colors.primaryOpacity[2],
              color: theme.colors.other[2],
              fontWeight: "bold",
            },
          },
        },
      }),
    },
    MultiSelect: {
      styles: (theme) => ({
        root: {},

        icon: {
          left: "16px",
        },
        rightSection: {
          right: "6px",
          pointerEvents: "none",
          width: "45px",
        },
        dropdown: {
          borderRadius: "0 0 8px 8px",
          background: theme.colors.other[6],
          border: `1.5px solid ${theme.colors.primary[1]}`,
          borderTop: "none",
          marginTop: "-15px",
        },
        item: {
          borderRadius: "0",
          paddingTop: "16px",
          height: "56px",
          background: theme.colors.basic[0],
          borderTop: `1px solid ${theme.colors.basic[3]}`,
          ":hover": {
            background: theme.colors.primaryOpacity[2],
          },
          "&[data-selected]": {
            "&, &:hover": {
              backgroundColor: theme.colors.primaryOpacity[2],
              color: theme.colors.other[2],
              fontWeight: "bold",
            },
          },
        },
        // Estilização dos chips dentro do MultiSelect
        pill: {
          backgroundColor: theme.colors.primary[2],
          color: "#ffffff",
          fontWeight: "bold",
          borderRadius: "8px",
          padding: "4px 8px",
        },
        values: {
          gap: "4px",
          paddingLeft: "60px",
        },
      }),
    },
    PasswordInput: {
      styles: (theme) => ({
        input: {
          borderRadius: "8px",
          WebkitBorderRadius: "8px",
          height: "56px !important",
          ":hover": {
            borderColor: theme.colors.primary[1],
          },
          ":focus-within": {
            borderColor: theme.colors.primary[1],
          },
        },
        wrapper: {
          marginBottom: "0px !important",
          height: "56px !important",
          boxSizing: "border-box",
          borderRadius: "8px",
          WebkitBorderRadius: "8px",
          outline: `1.5px solid ${theme.colors.basic[2]}`,
          fontFamily: "Montserrat",
          fontStyle: "normal",
          input: {
            paddingLeft: "44px !Important",
            border: "none",
            width: "100%",
            paddingRight: "120px",
            textOverflow: "ellipsis",
            ":hover": {
              borderColor: theme.colors.primary[1],
            },
            ":focus-visible": {
              fontWeight: "bolder",
              color: theme.colors.basic[5],
              background: theme.colors.basic[1],
              borderColor: "red",
            },
            ":disabled": {
              background: theme.colors.basic[2],
              opacity: "1",
              "::placeholder": {
                color: "red",
              },
            },
          },
        },
        rightSection: {
          whiteSpace: "nowrap",
          fontSize: "14px",
          width: "fit-content",
          justifyContent: "end",
          button: {
            ":hover": {
              background: "transparent ",
            },
            display: "flex",
            justifyContent: "right",
          },
          p: {
            fontSize: "14px",
            color: theme.colors.basic[5],
            textAlign: "right",
          },
        },
      }),
    },
    Checkbox: {
      styles: (theme) => ({
        body: { height: "28px", alignItems: "center" },
        input: {
          height: "20px",
          width: "20px",
          borderRadius: "8px",
          border: "2px solid",
          borderColor: theme.colors.basic[4],
        },
        icon: {
          height: "16px",
          width: "16px",
        },
        label: {
          fontSize: "16px",
          fontWeight: 500,
          color: theme.colors.basic[5],
          paddingLeft: "8px",

          a: {
            paddingLeft: "6px",
            color: theme.colors.primary[1],
            fontWeight: 600,
            textDecoration: "underline",
          },
        },
      }),
    },
    Radio: {
      styles: (theme) => ({
        body: { height: "28px", alignItems: "center" },
        radio: {
          height: "20px",
          width: "20px",
          border: "2px solid",
          borderColor: theme.colors.basic[4],
          ":checked": {
            background: "primary.0",
          },
        },
        inner: {
          alignSelf: "center",
        },
        icon: {
          height: "16px",
          width: "16px",
          margin: "-4px -4px",
          fill: theme.colors.basic[0],
        },
        description: {
          margin: "0",
          fontWeight: 500,
          fontSize: "12px",
        },
        label: {
          color: "#2F2F2F ",
          fontSize: "14px",
          fontWeight: 500,
          paddingLeft: "8px",
        },
      }),
    },
    RadioGroup: {
      styles: (theme) => ({
        label: {
          fontWeight: 600,
          span: {
            marginLeft: "8px",
            color: theme.colors.alerts[0],
            fontWeight: 600,
            fontSize: "16px",
          },
        },
      }),
    },
    Group: {
      styles: () => ({
        root: {
          gap: "44px",
        },
      }),
    },
    Tabs: {
      styles: (theme) => ({
        tabsList: {
          borderBottom: "none",
        },
        tab: {
          fontSize: "16px",
          lineHeight: "155%",
          color: theme.colors.basic[5],
          padding: "8px 20px",
          borderBottom: "3px solid",
          borderColor: "transparent",
          borderRadius: "3px",
          transition: "0.3s linear",
          "&[data-active]": {
            fontWeight: 600,
            borderColor: theme.colors.primary[1],
            transition: "0.3s linear",
            ":hover": {
              transition: "0.3s linear",
              background: "transparent",
              borderColor: theme.colors.complementary[6],
              filter: "brightness(1.2)",
            },
          },
          ":hover": {
            transition: "0.3s linear",
            background: "transparent",
            borderColor: theme.colors.complementary[6],
          },
        },
        tabRightSection: {
          marginLeft: "8px !important",
        },
      }),
    },
    Badge: {
      styles: () => ({
        root: {
          lineHeight: "155%",
          fontWeight: 500,
        },
      }),
    },
    NavLink: {
      styles: () => ({
        root: {
          width: "auto",
          fontSize: "16px",
          span: {
            margin: 0,
          },
          ":hover": {
            background: "transparent",
          },
        },
      }),
    },
    SegmentedControl: {
      styles: (theme) => ({
        root: {
          background: theme.colors.primaryOpacity[1],
          width: "fit-content",
          gap: "12px",
          borderRadius: "8px",
          padding: "9px",
          height: "fit-content",
        },
        label: {
          fontFamily: "Barlow",
          color: theme.colors.primary[0],
          fontWeight: 500,
          lineHeight: "155%",
          fontSize: "14px",
          padding: "8px 11px",
          ":hover": {
            color: theme.colors.other[2],
          },
          "&[data-active]": {
            color: theme.colors.other[0],
          },
          "&[data-active]:hover": {
            color: theme.colors.other[0],
          },
          justifyContent: "space-between",
          width: "fit-content",
          borderRadius: "8px",
        },
        control: {
          paddingLeft: "4px",
          border: "none !important",
          background: "transparent",
          transition: "0.3s linear",
        },
        indicator: {
          top: "4px",
          left: "8px",
          height: "48px",
          borderRadius: "50px",
          background: theme.colors.primary[2],
        },
        controlActive: {
          background: "transparent",
          transition: "0.3s linear",
        },
      }),
    },
    PinInput: {
      styles: () => ({
        root: {
          justifyContent: "space-between",
          gap: "8px",
        },
        wrapper: {
          margin: "0 !important",
        },
        input: {
          width: "80px",
          fontSize: "28px !important",
          fontWeight: 600,
        },
      }),
    },
    Tooltip: {
      styles: (theme) => ({
        tooltip: {
          fontSize: "14px",
          lineHeight: "21px",
          fontWeight: 400,
          padding: "12px",
          borderRadius: "8px",
          color: theme.colors.basic[0],
          background: theme.colors.basic[5],
        },
      }),
    },
    Button: {
      styles: () => ({
        root: {
          minHeight: "56px",
          height: "auto",
          borderRadius: "8px",
          transition: "0.3s linear",
          fontSize: "16px",
          lineHeight: "24.8px",
          fontWeight: 600,
          padding: "12px 12px",

          "&[data-disabled]": {
            cursor: "not-allowed !important",
          },
        },
        leftIcon: {
          marginRight: "12px",
          // paddingBottom: "5px",
        },
        rightIcon: {
          marginLeft: "12px",
          // paddingBottom: "5px",
        },
        group: {
          borderRadius: "50px !important",
        },
        label: {
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
          textAlign: "center",
        },
        inner: {
          "&[data-disabled]": {
            cursor: "not-allowed !important",
          },
        },
      }),
      variants: {
        primary: (theme) => ({
          root: {
            background: theme.colors.primary[0],
            color: theme.colors.basic[0],
            zIndex: 1,
            overflow: "hidden",
            opacity: "1",
            ...theme.fn.hover({
              border: "unset",
              color: theme.colors.basic[0],
              background: theme.colors.primary[1],
            }),

            "&[data-disabled]": {
              background: theme.colors.other[1],
              color: theme.colors.basic[0],
            },
          },
        }),
        primaryOutline: (theme) => ({
          root: {
            color: theme.colors.primary[0],
            border: "1px solid",
            borderColor: theme.colors.primary[0],
            ...theme.fn.hover({
              color: theme.colors.primary[1],
              borderColor: theme.colors.primary[1],
              background: theme.colors.primaryOpacity[2],
            }),
            "&[data-disabled]": {
              color: theme.colors.basic[4],
              borderColor: theme.colors.basic[4],
            },
          },
        }),
        primaryTransparent: (theme) => ({
          root: {
            color: theme.colors.primary[0],
            ...theme.fn.hover({
              color: theme.colors.primary[1],
              background: theme.colors.primaryOpacity[2],
            }),
            "&[data-disabled]": {
              color: theme.colors.basic[4],
            },
          },
        }),
        secondary: (theme) => ({
          root: {
            color: theme.colors.primary[0],
            background: theme.colors.basic[0],
            ...theme.fn.hover({
              background: theme.colors.primaryOpacity[2],
              color: theme.colors.primary[1],
            }),
            "&[data-disabled]": {
              background: theme.colors.basic[3],
              color: theme.colors.basic[1],
              cursor: "not-allowed",
            },
          },
        }),
        secondaryOutline: (theme) => ({
          root: {
            color: theme.colors.basic[0],
            background: "transparent",
            border: "1px solid",
            borderColor: theme.colors.basic[0],
            ...theme.fn.hover({
              background: "rgba(255, 255, 255, 0.2)",
            }),
            "&[data-disabled]": {
              color: theme.colors.basic[4],
              borderColor: theme.colors.basic[4],
              background: "transparent",
            },
          },
        }),
        secondaryTransparent: (theme) => ({
          root: {
            color: theme.colors.basic[0],
            background: "transparent",
            ...theme.fn.hover({
              background: "rgba(255, 255, 255, 0.2)",
            }),
            "&[data-disabled]": {
              background: "transparent",
              color: theme.colors.basic[4],
            },
          },
        }),
        danger: (theme) => ({
          root: {
            color: theme.colors.basic[0],
            background: theme.colors.alerts[0],
            zIndex: 1,
            overflow: "hidden",
            opacity: "1",

            ...theme.fn.hover({
              border: "unset",
              color: theme.colors.basic[0],
              background: theme.colors.alerts[3],
              ":before": {
                opacity: "1",
              },
            }),
            ":before": {
              position: "absolute",
              content: "''",
              top: "0",
              right: "0",
              bottom: "0",
              left: "0",
              background: theme.colors.alerts[3],
              zIndex: -1,
              transition: "0.3s linear",
              opacity: "0",
            },

            "&[data-disabled]": {
              background: theme.colors.basic[4],
              color: theme.colors.basic[1],
            },
          },
        }),
        dangerOutline: (theme) => ({
          root: {
            color: theme.colors.alerts[0],
            border: "1px solid",
            borderColor: theme.colors.alerts[0],
            ...theme.fn.hover({
              background: theme.colors.alertsOpacity[0],
              color: theme.colors.alerts[0],
            }),
            "&[data-disabled]": {
              color: theme.colors.basic[4],
              borderColor: theme.colors.basic[4],
            },
          },
        }),
        dangerTransparent: (theme) => ({
          root: {
            color: theme.colors.alerts[0],
            ...theme.fn.hover({
              background: theme.colors.alertsOpacity[0],
              color: theme.colors.alerts[0],
            }),
            "&[data-disabled]": {
              color: theme.colors.basic[4],
            },
          },
        }),
        transparentEspecial: (theme) => ({
          root: {
            color: theme.colors.basic[0],
            background: "rgba(255, 255, 255, 0.1)",
            ...theme.fn.hover({
              background: "rgba(255, 255, 255, 0.15)",
              WebkitTextFillColor: "primary.0",
            }),
            "&[data-disabled]": {
              background: "transparent",
              color: theme.colors.basic[4],
            },
          },
        }),
        login: (theme) => ({
          root: {
            padding: "16px ",
            border: "1px solid",
            borderColor: theme.colors.basic[2],
            ...theme.fn.hover({
              background: theme.colors.primaryOpacity[2],
              borderColor: theme.colors.primary[1],
            }),
          },
          inner: {
            justifyContent: "space-between",
          },
          rightIcon: {
            color: theme.colors.basic[5],
          },
          label: {
            flexDirection: "column",
            height: "auto",
            alignItems: "start",
            fontWeight: 600,
            fontSize: "20px",
            lineHeight: "31px",
            color: theme.colors.basic[5],
            span: {
              WebkitTextFillColor: theme.colors.basic[4],
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "24.8px",
            },
          },
        }),
        recoverPassword: (theme) => ({
          root: {
            padding: "16px ",
            border: "1px solid",
            borderColor: theme.colors.basic[2],
            ...theme.fn.hover({
              background: theme.colors.primaryOpacity[2],
              borderColor: theme.colors.primary[1],
            }),
          },
          inner: {
            justifyContent: "left",
          },
          rightIcon: {
            marginLeft: "auto",
          },
          label: {
            fontWeight: 400,
            fontSize: "20px",
          },
          leftIcon: {
            marginRight: "16px",
            height: "48px",
            width: "48px",
            background: theme.colors.primaryOpacity[1],
            borderRadius: "8px",
            WebkitBorderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        }),
        link: (theme) => ({
          root: {
            ":focus": {
              outline: "none",
            },
          },
          label: {
            color: theme.colors.primary[1],
            textDecoration: "underline",
            fontWeight: 600,
            fontSize: "14px",
            ":focus": {},
          },
        }),
        details: (theme) => ({
          root: {
            background: theme.colors.primary[1],
            color: theme.colors.basic[0],
            zIndex: 1,
            overflow: "hidden",
            opacity: "1",
            borderRadius: "0 10px 10px 0 !important",
            ...theme.fn.hover({
              border: "unset",
              filter: "brightness(1.2)",
            }),

            "&[data-disabled]": {
              background: theme.colors.other[1],
              color: theme.colors.basic[0],
            },
          },
        }),
        segments: (theme) => ({
          root: {
            width: "56px",
            outline: "none",
            background: theme.colors.primaryOpacity[1],
            color: theme.colors.basic[5],
            zIndex: 1,
            overflow: "hidden",
            opacity: "1",
            borderRadius: "50px !important",
            ...theme.fn.hover({
              svg: {
                transition: "all 0.5s ease-in-out",
                height: "30px",
                width: "30px",
              },
            }),
          },
        }),
        table: (theme) => ({
          root: {
            padding: "0 !important",
            outline: "none",
            background: "inset",
            color: theme.colors.basic[5],
            zIndex: 1,
            overflow: "hidden",
          },
          inner: {
            justifyContent: "space-between",
          },
        }),
        modal: (theme) => ({
          root: {
            padding: "10px !important",
            outline: "none",
            background: "inset",
            color: theme.colors.basic[5],
            zIndex: 1,
            overflow: "hidden",
            ...theme.fn.hover({
              background: theme.colors.primaryOpacity[0],
            }),
          },
          inner: {
            justifyContent: "flex-start",
          },
        }),
        modalDanger: (theme) => ({
          root: {
            padding: "10px !important",
            outline: "none",
            background: "inset",
            zIndex: 1,
            overflow: "hidden",
            ...theme.fn.hover({
              background: theme.colors.complementaryOpacity[2],
            }),
          },
          inner: {
            color: theme.colors.alerts[0],
            justifyContent: "flex-start",
          },
        }),
        optionYes: (theme) => ({
          root: {
            background: theme.colors.complementaryOpacity[6],
            color: theme.colors.complementary[6],
            zIndex: 1,
            overflow: "hidden",
            opacity: "1",
            height: "20px",
            minHeight: "20px !important",
            padding: "0 6px 0 6px !important",
            borderRadius: "4px !important",
            ...theme.fn.hover({
              border: "unset",
              background: theme.colors.complementary[6],
              color: theme.colors.complementaryOpacity[6],
            }),
            "&[data-active='true']": {
              border: "unset",
              background: theme.colors.complementary[6],
              color: theme.colors.complementaryOpacity[6],
            },
            "&[data-disabled]": {
              background: theme.colors.other[1],
              color: theme.colors.basic[0],
            },
          },
          label: {
            fontSize: "11px",
          },
        }),
        optionNo: (theme) => ({
          root: {
            background: theme.colors.complementaryOpacity[4],
            color: theme.colors.complementary[4],
            zIndex: 1,
            overflow: "hidden",
            opacity: "1",
            height: "20px",
            minHeight: "20px !important",
            padding: "0 6px 0 6px !important",
            borderRadius: "4px !important",
            ...theme.fn.hover({
              border: "unset",
              background: theme.colors.complementary[4],
              color: theme.colors.complementaryOpacity[4],
            }),
            "&[data-active='true']": {
              border: "unset",
              background: theme.colors.complementary[4],
              color: theme.colors.complementaryOpacity[4],
            },
            "&[data-disabled]": {
              background: theme.colors.other[1],
              color: theme.colors.basic[0],
            },
          },
          label: {
            fontSize: "11px",
          },
        }),
      },
    },
    ActionIcon: {
      styles: () => ({
        root: {
          transition: "0.3s linear",
          "&[data-disabled]": {
            cursor: "not-allowed !important",
          },
        },
      }),
      variants: {
        secondary: (theme) => ({
          root: {
            padding: "8px",
            height: "44px",
            width: "44px",
            border: "1px solid",
            borderRadius: "50%",
            borderColor: theme.colors.basic[2],
            color: theme.colors.basic[5],
            background: theme.colors.basic[0],
            ...theme.fn.hover({
              borderColor: "transparent",
              color: theme.colors.primary[1],
              background: theme.colors.primaryOpacity[2],
            }),
            "&[data-disabled]": {
              background: theme.colors.basic[4],
              color: theme.colors.basic[1],
            },
          },
        }),
        transparentEspecial: (theme) => ({
          root: {
            padding: "8px",
            height: "44px",
            width: "44px",
            borderRadius: "50%",
            color: theme.colors.basic[0],
            background: "rgba(255, 255, 255, 0.1)",
            ...theme.fn.hover({
              background: "rgba(255, 255, 255, 0.15)",
              WebkitTextFillColor: "primary.0",
            }),
            "&[data-disabled]": {
              background: "transparent",
              color: theme.colors.basic[4],
            },
          },
        }),
        visualization: (theme) => ({
          root: {
            padding: "8px",
            height: "40px",
            width: "40px",
            borderRadius: "8px",
            color: theme.colors.basic[5],
            background: "transparent",
            ...theme.fn.hover({
              background: theme.colors.primaryOpacity[1],
            }),
            "&[data-disabled]": {
              background: "transparent",
              color: theme.colors.basic[4],
            },
          },
        }),
        remove: (theme) => ({
          root: {
            padding: "8px",
            height: "40px",
            width: "40px",
            borderRadius: "8px",
            color: theme.colors.basic[5],
            background: "transparent",
            ...theme.fn.hover({
              background: theme.colors.alertsOpacity[0],
              color: theme.colors.alerts[0],
            }),
            "&[data-disabled]": {
              background: "transparent",
              color: theme.colors.basic[4],
            },
          },
        }),
      },
    },
    modal: {
      styles: () => ({
        overlay: {
          background: "rgba(0, 0, 0, 0.6)",
        },
      }),
    },
    Notification: {
      styles: (theme) => ({
        root: {
          position: "relative",
          zIndex: 9999,
          backgroundColor: theme.colors.primaryOpacity[1],
          border: "unset",
          maxWidth: "454px",
          width: "100%",
          padding: "16px",
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
          "&::before": {
            backgroundColor: theme.colors.primary[0],
            margin: "16px 10px 16px 0",
            left: "8px",
          },
        },

        icon: {
          margin: "0",
        },

        loader: {
          margin: "0",
        },

        title: {
          color: theme.colors.basic[5],
          fontWeight: 600,
          fontSize: "16px",
          marginLeft: "12px",
        },

        description: {
          color: theme.colors.basic[5],
          opacity: 0.5,
          fontWeight: 400,
          fontSize: "16px",
          marginLeft: "12px",
        },

        closeButton: {
          width: "28px",
          height: "28px",
          color: theme.colors.basic[4],
          "&:hover": {
            backgroundColor: "unset",
            color: theme.colors.basic[5],
            scale: "1.1",
          },
          svg: {
            width: "28px",
            height: "28px",
          },
        },
      }),
    },
  },
};
